// extracted by mini-css-extract-plugin
module.exports = {"member":"styles_member__1Kqus","links":"styles_links__3iPl2","linksContainer":"styles_linksContainer__2_crw"};